import { FilterOption } from '@root/core/interfaces';
import { Form, Input, Radio, Select } from 'antd';
import { useEffect, useState } from 'react';
import { AIR_SELECT } from '../details-pro/types';

interface ShipmentMethod {
  shipmentMethod: string;
  shipmenDetail?: string;
  isUpdate?: Boolean;
  onchange?: Function;
}
function ShipmentMethodCanEdit({
  shipmentMethod,
  shipmenDetail,
  isUpdate,
  onchange
}: ShipmentMethod) {
  const [form] = Form.useForm();
  const [disabled, setDisabled] = useState<boolean>(true);
  const [isDirectInput, setIsDirectInput] = useState<boolean>(false);
  const [isAIR, setAIR] = useState<boolean>(false);

  useEffect(() => {
    if (isUpdate) {
      setDisabled(false);
    }
  }, [isUpdate]);

  useEffect(() => {
    const isDirect = !AIR_SELECT.map((v) => v.value).includes(shipmenDetail!);
    form.setFieldsValue({
      shipmentMethod,
      shipmenDetail: isDirect ? 'Direct input' : shipmenDetail,
      shipmenDetailInput: isDirect ? shipmenDetail : '',
      shipmenDetailOcean: shipmentMethod === 'Ocean' ? shipmenDetail : ''
    });
    setAIR(shipmentMethod === 'AIR');
    setIsDirectInput(isDirect);
  }, [shipmentMethod, shipmenDetail]);

  return (
    <>
      <Form
        form={form}
        onFieldsChange={(v) => {
          setTimeout(() => {
            const data = form.getFieldsValue();
            let shipmentDetail = data.shipmenDetail;
            if (isAIR) {
              if (shipmentDetail === 'Direct input') {
                shipmentDetail = data.shipmenDetailInput;
              }
            } else {
              shipmentDetail = data.shipmenDetailOcean;
            }

            onchange?.({
              shipmentMethod: data?.shipmentMethod,
              shipmentDetail
            });
          });
        }}
        layout="vertical"
        style={{ width: '100%', height: '130px' }}
      >
        <div className="shipmentMethod" style={{ height: '100%' }}>
          <p>Shipment Method</p>
          <Form.Item name="shipmentMethod">
            <Radio.Group
              disabled={disabled}
              onChange={(e) => {
                setAIR(e.target.value === 'AIR');
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Radio value="AIR">Air | Carrier</Radio>

                {isAIR ? (
                  <div>
                    <Form.Item name="shipmenDetail">
                      <Select
                        disabled={disabled}
                        onChange={(e: string) => {
                          setIsDirectInput(e === 'Direct input');
                        }}
                      >
                        {AIR_SELECT.map((item: FilterOption) => (
                          <Select.Option key={item.value} value={item.value}>
                            {item.label}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                    {isDirectInput ? (
                      <Form.Item name="shipmenDetailInput">
                        <Input disabled={disabled} />
                      </Form.Item>
                    ) : null}
                  </div>
                ) : null}
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Radio value="Ocean">Ocean</Radio>
                {!isAIR ? (
                  <div>
                    <Form.Item name="shipmenDetailOcean">
                      <Input disabled={disabled} />
                    </Form.Item>
                  </div>
                ) : null}
              </div>
            </Radio.Group>
          </Form.Item>
        </div>
      </Form>
    </>
  );
}

export default ShipmentMethodCanEdit;
